export default __webpack_public_path__ + "assets/c6c012b47860f4e8ee94549b88fed149.svg";